import { optimove } from 'js/analytics/adapters'
export const trackLimitedLogin = id => {
  optimove.user({ id })
}
